import React from 'react';
import Hero from '../components/sections/Hero';
import ProblemSolution from '../components/sections/ProblemSolution';
import PartnerWithUs from '../components/sections/PartnerWithUs';
import Features from '../components/sections/Features';
import WhyUs from '../components/sections/WhyUs';
import CTA from '../components/sections/CTA';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <ProblemSolution />
      <PartnerWithUs />
      <Features />
      <WhyUs />
      <CTA />
    </div>
  );
};

export default Home;